import styled from '@emotion/styled';
import Chip from '@mui/material/Chip';
import { gray06, gray01 } from 'presentations/views/styles/color';
import { spacing, fontWeight, borderRadius } from 'presentations/views/styles';

const Tag = styled(Chip)`
  border-radius: ${borderRadius()};
  background-color: ${gray06};
  margin: ${spacing(8)};
  border: 0;
  .MuiChip-deleteIcon {
    color: ${gray01};
  }
`;
export default Tag;
